import axios from 'axios'

// 创建基础配置
const http = axios.create({
    baseURL: '/'
})

//返回状态判断(添加响应拦截器)
http.interceptors.response.use(response =>{
    const data = response.data
    // 判断是否为对象
    if(data instanceof Object) {
        return response.data
    }
    return Promise.reject(data);
}, (error) => {
    return Promise.reject(error);
})

export default http